export const FETCH_VERIFY_THERMIT_LOGIN_REQUEST = 'FETCH_VERIFY_THERMIT_LOGIN_REQUEST'
export const FETCH_VERIFY_THERMIT_LOGIN_SUCCESS = 'FETCH_VERIFY_THERMIT_LOGIN_SUCCESS'
export const FETCH_VERIFY_THERMIT_LOGIN_FALUIRE = 'FETCH_VERIFY_THERMIT_LOGIN_FALUIRE'
export const FETCH_CLEAR_ERROR_MESSAGE='FETCH_CLEAR_ERROR_MESSAGE'

